import { environmentHttpClient } from "../httpClient";

export type CommunitiesSettingsModel = {
	isEnabled: boolean;
};

export function getCommunitiesSettings(signal?: AbortSignal): Promise<CommunitiesSettingsModel> {
	return environmentHttpClient.get<CommunitiesSettingsModel >(
		"UiApi/Communities/Settings",
		undefined,
		{ signal }
	);
}

export function saveCommunitiesSettings(
	model: CommunitiesSettingsModel,
	signal?: AbortSignal
): Promise<CommunitiesSettingsModel> {
	return environmentHttpClient.put<CommunitiesSettingsModel >(
		"UiApi/Communities/Settings",
		model,
		{ signal }
	);
}
